import * as types from "../types";

const initialState = {
  colors: [],
  gradientColors: [],
};

const colorReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.ADD_COLOR:
      if (!state.colors.includes(action.payload)) {
        return {
          ...state,
          colors: [...state.colors, action.payload],
        };
      }
      return state;

    case types.REMOVE_COLOR:
      return {
        ...state,
        colors: state.colors.filter((color) => color !== action.payload),
      };

    case types.UPDATE_COLOR:
      return {
        ...state,
        colors: state.colors.map((color) =>
          color === action.payload.oldColor ? action.payload.newColor : color
        ),
      };

    case types.ADD_GRADIENT_COLOR:
      if (!state.gradientColors.includes(action.payload)) {
        return {
          ...state,
          gradientColors: [...state.gradientColors, action.payload],
        };
      }
      return state;

    case types.REMOVE_GRADIENT_COLOR:
      return {
        ...state,
        gradientColors: state.gradientColors.filter(
          (gradientColor) => gradientColor !== action.payload
        ),
      };

    case types.UPDATE_GRADIENT_COLOR:
      return {
        ...state,
        gradientColors: state.gradientColors.map((gradientColor) =>
          gradientColor === action.payload.oldGradientColor
            ? action.payload.newGradientColor
            : gradientColor
        ),
      };

    default:
      return state;
  }
};

export default colorReducer;
